import React, { useCallback, useEffect, useState } from "react";


import { Button, Dropdown, Form, Input, Menu, Modal, PageHeader, Select, Table, Tag } from "antd";
import { crud } from "@/redux/crud/actions";
import { useDispatch, useSelector } from "react-redux";
import { selectItemById, selectListItems, selectUpdatedItem } from "@/redux/crud/selectors";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, EyeOutlined } from "@ant-design/icons";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Switch } from 'antd';
import uniqueId from "@/utils/uinqueId";
import SearchItem from "@/components/SearchItem";
import HeaderContent from "@/layout/HeaderContent";
import Loading from "@/components/Loading";
import { API_BASE_URL } from "@/config/serverApiConfig";
import axios from "axios";
import TextArea from "antd/lib/input/TextArea";
import { Option } from "antd/lib/mentions";

function Category() {
    const entity = "category";
    const searchConfig = {
        // displayLabels: ["fname", "lname", "email"],
        displayLabels: ["email"],
        searchFields: "fname,lname,email",
        outputValue: "_id",
    };
    const { current, isLoading, isSuccess } = useSelector(selectUpdatedItem);

    let [note, setNote] = useState("");
    const [loadForm, setLoadForm] = useState(true)
    const [loadFormView, setLoadFormView] = useState(true)
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(false);

    let [data, setData] = useState([]);

    let [edit_id, set_edit_id] = useState(0);
    const [visible, setVisible] = useState(false);
    const [visibleView, setVisibleView] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [confirmLoadingView, setConfirmLoadingView] = useState(false);
    const [modalText, setModalText] = useState('Content of the modal');
    const [form] = Form.useForm();

    const [isModalVisible, setIsModalVisible] = useState(false);
    let history = useHistory();
    const panelTitle = "Business Category ";
    const dataTableTitle = "Business Category Lists";
    const entityDisplayLabels = ["company"];

    const { result: listResult, isLoading: listIsLoading } = useSelector(
        selectListItems
    );
    const { pagination, items } = listResult;

    const ADD_NEW_ENTITY = "View Pending Approval User";
    const DATATABLE_TITLE = "Business Category List";
    const ENTITY_NAME = "Business Category";
    const CREATE_ENTITY = "Create Business Category";
    const UPDATE_ENTITY = "Update Business Category";



    const readColumns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Parent Category",
            dataIndex: "parent_category_name",
        },
        {
            title: "Status",
            dataIndex: "isActive",
        },

    ];

    const [deactiveData, setDeactiveData] = useState({});
    const showModalNote = ({ row }) => {
        setDeactiveData(row)
        setIsModalVisible(true)
    }
    const handleCancelNote = () => {
        setIsModalVisible(false)
    }
    const dataTableColumns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Parent Category",
            dataIndex: "parent_category_name",
        },
        {
            title: "Status",
            render: (row) => {

                return (
                    <>
                        <Tag color={row.isActive ? "green" : "red"} >
                            {row.isActive ? "Active" : "Deactive"}
                        </Tag>
                    </>
                );





            }
        },

        {
            title: "",
            render: (row) => (
                <Dropdown overlay={DropDownRowMenu({ row })} trigger={["click"]}>
                    <EllipsisOutlined style={{ cursor: "pointer", fontSize: "24px" }} />
                </Dropdown>
            ),
        },

    ];

    const onChangeSwitch = ({ row }) => {
        row.status = true;
        dispatch(crud.update(entity, row._id, row));
    }

    const handelDataTableLoad = useCallback((pagination) => {
        dispatch(crud.list(entity, pagination.current));
    }, []);

    function DropDownRowMenu({ row }) {
        // const dispatch = useDispatch();
        // const { crudContextAction } = useCrudContext();
        // const { panel, collapsedBox, modal, readBox, editBox } = crudContextAction;
        // const item = useSelector(selectItemById(row._id));

        function Delete() {
            const id = current._id;
            dispatch(crud.delete(entity, id));
            // dispatch(crud.currentAction("delete", item));
            dispatch(crud.list(entity));
            // modal.open();
        }
        return (
            <Menu style={{ width: 130 }}>
                <Menu.Item key={`${uniqueId()}`} icon={<EyeOutlined />} onClick={() => showModal(row._id, false)}>
                    View
                </Menu.Item>
                <Menu.Item key={`${uniqueId()}`} icon={<EditOutlined />} onClick={() => showModal(row._id, true)} >
                    Edit
                </Menu.Item>
                <Menu.Item
                    key={`${uniqueId()}`}
                    icon={<DeleteOutlined />}
                    onClick={() => { showDeleteModal(row._id) }}
                >
                    Delete
                </Menu.Item>
            </Menu>
        );
    }



    const showModal = (id, isEdit) => {
        set_edit_id(id)
        if (isEdit) {

            setVisible(true);
        }
        else {
            setVisibleView(true);
        }
        axios(`${API_BASE_URL}${entity}/read/${id}`)
            .then(res => {
            
                setData(res.data.result)
                if (isEdit) {

                    setLoadForm(false)
                    form.setFieldsValue(
                        {
                            name: res.data.result.name,
                            parent_id: res.data.result.parent_id,
                            note: res.data.result.note,
                            isActive: res.data.result.isActive

                        }
                    );
                }
                else {
                    setLoadFormView(false)
                }
            })
            .catch(err => {
            
            })
    };

    const handleOk = () => {
        setModalText('The modal will be closed after two seconds');
        setConfirmLoading(true);
        setTimeout(() => {
            setVisible(false);
            setConfirmLoading(false);
        }, 2000);
    };

    const handleCancel = (isEdit) => {
        if (isEdit) {

            setVisible(false);
        }
        else {
            setVisibleView(false);
        }
    };
    const onSubmit = () => {
        dispatch(crud.update(entity, edit_id, form.getFieldValue()));
        dispatch(crud.list(entity, pagination.current));
        setVisible(false);
    }


    // const handelDataTableLoad = useCallback((pagination) => {
    //     dispatch(crud.list("user", pagination.current));
    //   }, []);

    useEffect(() => {
        if (isSuccess) {
            dispatch(crud.resetAction("update"));
            // dispatch(crud.list(entity));
        }
    }, [isSuccess]);
    
    useEffect(() => {
        dispatch(crud.list(entity));
    }, []);

    const [formAdd] = Form.useForm();
    const config = {
        entity,
        panelTitle,
        dataTableTitle,
        ENTITY_NAME,
        CREATE_ENTITY,
        ADD_NEW_ENTITY,
        UPDATE_ENTITY,
        DATATABLE_TITLE,
        readColumns,
        dataTableColumns,
        searchConfig,
        entityDisplayLabels,
    };
    let [category, setCategory] = useState([]);
    useEffect(() => {
        axios(`${API_BASE_URL}category/getCategory`)
            .then(res => {
                setCategory(res.data.data)
            })
            .catch(err => {
            
                
            })
    }, []);
    function onChange({ target: { value } }) {
        setNote(value)
    };
    const handleCancelAdd = () => {
        setVisibleAdd(false);
    };
    const onSubmitAdd = () => {
        console.log(formAdd.getFieldValue())
        dispatch(crud.create(entity, formAdd.getFieldValue()));
        // dispatch(crud.update(entity, edit_id, form.getFieldValue()));
        dispatch(crud.list(entity, pagination.current));
        setVisibleAdd(false);
    }

    const [visibleAdd, setVisibleAdd] = useState(false);

    const [confirmLoadingAdd, setConfirmLoadingAdd] = useState(false);
    const [visibleViewDelete, setvisibleViewDelete] = useState(false);
    const showModalAdd = () => {
        setVisibleAdd(true);
    }
    const handleOkDelete = () => {
        dispatch(crud.delete(entity, deleteID));
        setvisibleViewDelete(false)
        // dispatch(crud.currentAction("delete", item));
        dispatch(crud.list(entity));
    };
    const handleCancelDelete = () => {
        setvisibleViewDelete(false);
    }
    const showDeleteModal = (deleteID) => {
    
        setDeleteID(deleteID)
        setvisibleViewDelete(true)
    }
    const [deleteID, setDeleteID] = useState('');
    return (
        <>
            <Modal
                title="Confirm"
                visible={visibleViewDelete}
                onOk={handleOkDelete}
                onCancel={handleCancelDelete}
            // footer={[]}
            >

                <p>Are you Sure you want to delete</p>

            </Modal>
            <Modal
                title="Add Category"
                visible={visibleAdd}
                onOk={handleOk}
                confirmLoading={confirmLoadingAdd}
                onCancel={() => { handleCancelAdd() }}
                footer={[
                    <Button key="back" onClick={() => { handleCancelAdd() }}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" onClick={onSubmitAdd}>
                        Submit
                    </Button>,

                ]}
            >
                <Form name="control-hooks" form={formAdd} >
                    <Form.Item
                        label="Category Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please input Category name!",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item label="Parent" name="parent_id">
                        <Select >
                            <Select.Option value="">None</Select.Option>
                            {/* {category} */}
                            {category.filter(cat => cat.isParent === true ).map((value, index) => {
                                return <Select.Option value={value._id} key={index}>{value.name}</Select.Option>
                            })}

                        </Select>
                    </Form.Item>
                    <Form.Item name="note" label="Note">
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item label="Active" name="isActive">
                        {/* set by default option active and value true */}
                        <Switch defaultChecked={true} />

                        {/* <Select > 
                        
                            <Select.Option value={true}>Active</Select.Option>
                            <Select.Option value={false}>Deactivate</Select.Option>
                        </Select> */}
                        
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Edit Category"
                visible={visible}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={() => { handleCancel(true) }}
                footer={[
                    <Button key="back" onClick={() => { handleCancel(true) }}>
                        Return
                    </Button>,
                    <Button key="submit" type="primary" onClick={onSubmit}>
                        Submit
                    </Button>,

                ]}
            >

                <Loading isLoading={loadForm}>
                    <Form name="control-hooks" form={form} >
                        <Form.Item
                            label="Category Name"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input Category name!",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item label="Parent" name="parent_id">
                            <Select >
                                <Select.Option value="">None</Select.Option>
                                {/* {category} */}
                                { category.filter(cat => cat.isParent === true ).map((value, index) => {
                                    return <Select.Option value={value._id} key={index}>{value.name}</Select.Option>
                                })}

                            </Select>
                        </Form.Item>
                        <Form.Item name="note" label="Note">
                            <Input.TextArea />
                        </Form.Item>
                        <Form.Item label="Active" name="isActive">
                            <Select >
                                <Select.Option value={true}>Active</Select.Option>
                                <Select.Option value={false}>Deactivate</Select.Option>
                            </Select>
                        </Form.Item>
                    </Form>
                </Loading>
            </Modal>
            <Modal
                title="View Category"
                visible={visibleView}
                onOk={handleOk}
                confirmLoading={confirmLoadingView}
                onCancel={() => { handleCancel(false) }}
                footer={[]}
            >

                <Loading isLoading={loadFormView}>

                <div class="card-body">
                                <table>


                                    <tbody>
                                        <tr>
                                            <th>Category Name :</th>
                                            <td>{(data.name && data) ? data.name : ''}</td>
                                        </tr>
                                        <tr>
                                            <th>Parent Category :</th>
                                            <td>{data.parent_category_name}</td>
                                        </tr>
                                        <tr>
                                            <th>Note :</th>
                                            <td>{(data.note && data) ? data.note : ''}</td>
                                        </tr>
                                        <tr>
                                            <th>Active :</th>
                                            <td>{data.isActive === true ? "Active" : 'Deactive'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    {/* <ul>
                        <li>Category Name : {data.name}</li>
                        <li>Parent        : Category Name Name : {data.parent_category_name}</li>
                        <li>Status        : {data.isActive ? "Active" : "Deactive"}</li>
                    </ul> */}
                </Loading>
            </Modal>
            <HeaderContent />
            <PageHeader
                onBack={() => window.history.back()}
                title={dataTableTitle}
                ghost={false}
                extra={[
                    <Button onClick={showModalAdd} key={`${uniqueId()}`}>
                        Add new Category
                    </Button>
                    ,
                ]}
                style={{
                    padding: "20px 10px",
                }}
            ></PageHeader>

            <div className="table" style={{ padding: "20px" }}>

                {/* <SearchItem config={config} /> */}
                <Loading isLoading={isLoading}>
                    <Table
                        columns={dataTableColumns}
                        rowKey={(item) => item._id}
                        dataSource={items}
                        pagination={pagination}
                        // loading={listIsLoading}
                        onChange={handelDataTableLoad}
                        scroll={{ x: 1500 }}
                    />
                </Loading>
            </div>
        </>
    );
}

export default Category;
